import { Car } from 'src/app/profile/_interfaces/car.model';

export const EMPTY_CAR: Car = {
  make: '',
  model: '',
  color: '',
  plate: '',
  isDefault: false,
};
